import React, { useEffect } from 'react';
import $ from 'jquery';



export const AuditTableRow = ({ activityLog}) => {
    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <div className="card p-2">
            <div className="row g-1 gx-md-2 align-items-center">
                <div className="col col-md-3 col-lg-2">
                    <div className="h5 ls-1 my-auto text-truncate">{new Intl.DateTimeFormat('fr-FR').format(activityLog.date)} {activityLog.date.toLocaleTimeString("fr-FR")}</div>
                </div>
                <div className="col-auto col-md-2">
                    <div className="h5 ls-1 my-auto o-70 text-truncate">{activityLog.operatorName}</div>
                </div>
                <div className="col-auto col-md-6">
                    <div className="h5 ls-1 my-auto o-70 text-truncate">{activityLog.description}</div>
                </div>
                <div className="col-auto col-md-2">
                    <div className="h5 ls-1 my-auto container-press ml-auto">{activityLog.userName}</div>
                </div>
            </div>
        </div>
    );
};